// extracted by css-extract-rspack-plugin
export default {"container":"container-OZYysr","item":"item-SuBa2D","itemSelected":"itemSelected-Bsvli4","itemLabel":"itemLabel-xko5N3","itemValue":"itemValue-Mq4oYi"};